import React, { PureComponent } from 'react'
import { Spin } from 'antd'

export default class PromiseRender extends PureComponent {

  state = {
    component: null,
  }

  componentDidMount () {
    this.setRenderComponent(this.props)
  }

  componentWillReceiveProps (nextProps) {
    this.setRenderComponent(nextProps)
  }

  /**
   * 写入返回组件是否准入:ok or error
   * @param props
   */
  setRenderComponent (props) {
    const ok = this.checkIsInstantiation(props.ok)
    const error = this.checkIsInstantiation(props.error)
    props.promise
      .then(() => {
        this.setState({
          component: ok,
        })
      })
      .catch(() => {
        this.setState({
          component: error,
        })
      })
  }

  /**
   * 判断传入的组件是否实例化
   * 如果已实例化则,返回
   * 未实例化则实例化后返回
   * @param target 组件
   * @return {*} 实例化后的组件
   */
  checkIsInstantiation = target => {
    if (!React.isValidElement(target)) {
      return target
    }
    return () => target
  }

  render () {
    const Component = this.state.component
    return Component ? (
      <Component {...this.props} />
    ) : (
      <div
        style={{
          width: '100%',
          height: '100%',
          margin: 'auto',
          paddingTop: 50,
          textAlign: 'center',
        }}
      >
        <Spin size="large"/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/components/Authorized/PromiseRender.js